import React, {useCallback, useRef} from 'react';

let c=0;
export const useDoubleClick = (callback, doubleClick=250, singleClickCallback) => {
    let ref = useRef(0);
    let id = useRef(c++);

    const onDoubleClick = useCallback((e) => {
        let date = new Date().getTime();
        let diff = date - ref.current;
        ref.current = date;
        if (diff <= doubleClick) {
            callback(e);
            return;
        }
        if (singleClickCallback) {
            singleClickCallback(e);
        }
    }, [callback, singleClickCallback]);

    return onDoubleClick;
};
